export default "__VITE_ASSET__Czwi1rDY__"